(function () {
  "use strict";
  var C = window.STORE_CONFIG;
  var NS = String((C.whop && C.whop.accountId) || "store");
  var KEY = "store-cart-v1:" + NS;
  var cents = function (d) { return d == null || d === "" ? null : Math.round(Number(d) * 100); };
  var money = function (c) { return "$" + (Number(c || 0) / 100).toFixed(2); };
  var offerById = function (id) { return C.offers.filter(function (o) { return o.id === String(id); })[0]; };
  var groupById = function (id) { return (C.addons || []).filter(function (g) { return g.id === id; })[0]; };
  var variantOf = function (g, id) { return g && g.variants.filter(function (v) { return v.id === String(id); })[0]; };
  var UN = C.unitName || {};
  var unitsLabel = function (n) { return n + " " + (n === 1 ? UN.one || "unit" : UN.many || "units"); };
  var SUBS = !!(C.subscriptions && C.subscriptions.enabled); // SUBSCRIPTIONS_OFF_BY_DEFAULT
  var listeners = [];
  var mem = null; // fallback when storage is unavailable

  function defaults() { return { offer: String(C.defaultOffer || C.offers[0].id), addons: {}, inCart: false }; }
  var addonRule = function (o, id) { return !o ? null : o.addons ? o.addons[id] || null : "paid"; };
  function clean(s) {
    var d = defaults(); s = s || {};
    var offer = offerById(s.offer) ? String(s.offer) : d.offer, addons = {}; // loadStock moves a selection off a sold-out offer
    (C.addons || []).forEach(function (g) { var v = s.addons && s.addons[g.id]; if (v != null && variantOf(g, v) && addonRule(offerById(offer), g.id) === "paid") addons[g.id] = String(v); });
    return { offer: offer, addons: addons, inCart: s.inCart === true };
  }

  var SID_KEY = "store-session", sid = null;
  try {
    sid = sessionStorage.getItem(SID_KEY);
    if (!sid) { sid = Date.now().toString(36) + Math.random().toString(36).slice(2, 10); sessionStorage.setItem(SID_KEY, sid); }
  } catch (e) { sid = null; }
  function read() {
    try { var raw = localStorage.getItem(KEY); if (raw) { var o = JSON.parse(raw); if (sid && o && o.sid === sid) return clean(o); } } catch (e) {}
    return clean(mem || defaults());
  }
  function write(s) {
    mem = s;
    try { localStorage.setItem(KEY, JSON.stringify({ offer: s.offer, addons: s.addons, inCart: s.inCart, sid: sid })); } catch (e) {}
  }

  var state = read();
  function set(patch) {
    var next = { offer: state.offer, addons: {}, inCart: state.inCart };
    Object.keys(state.addons).forEach(function (k) { next.addons[k] = state.addons[k]; });
    if ("offer" in patch) next.offer = patch.offer;
    if ("inCart" in patch) next.inCart = patch.inCart;
    if (patch.addons) Object.keys(patch.addons).forEach(function (k) { if (patch.addons[k] == null) delete next.addons[k]; else next.addons[k] = patch.addons[k]; });
    state = clean(next); write(state); emit();
  }
  function emit() { var o = order(); listeners.forEach(function (fn) { fn(state, o); }); }
  function reload() { state = read(); emit(); }
  window.addEventListener("storage", function (e) { if (e.key === KEY) reload(); });
  window.addEventListener("pageshow", function (e) { if (e.persisted) reload(); });

  function order(s, opts) {
    s = s || state; opts = opts || {};
    var o = offerById(s.offer), lines = [];
    lines.push({ key: "offer", name: C.productName, detail: o.title + " · " + (o.detail || unitsLabel(o.units)) + (stock.preorder ? " · Pre-order" : ""), price: cents(o.price), compareAt: cents(o.compareAt),
      image: o.image || null, qty: 1, units: o.units, plan: o.planId || null });
    (C.addons || []).forEach(function (g) {
      if (addonRule(o, g.id) === "free") {
        lines.push({ key: "addon:" + g.id, group: g.id, name: "Free " + g.name, detail: "Included", price: 0, compareAt: cents(g.variants[0].compareAt), image: g.image, qty: 1, free: true, plan: null });
        return;
      }
      var vid = s.addons[g.id]; if (vid == null) return;
      var v = variantOf(g, vid);
      lines.push({ key: "addon:" + g.id, group: g.id, variant: v.id, name: g.name, detail: v.label + " · one-time", price: cents(v.price), compareAt: cents(v.compareAt),
        image: g.image, qty: 1, removable: true, plan: v.planId || null });
    });
    var sub = null;
    if (SUBS) { // display line: $0.00 today (trial); the renewal terms come from the owner's disclosure
      var S = C.subscriptions;
      if (C.gift) {
        var giftQty = o.units * (C.gift.perUnit || 1);
        sub = { key: "subscription", name: "+ " + giftQty + " FREE " + C.gift.name, detail: (S.refillLabel || "Refills") + " every " + S.periodDays + " days",
          price: 0, compareAt: cents(S.renewalPrice), free: true, displayQty: giftQty, image: C.gift.image || null, qty: 1, plan: S.planId || null };
      } else sub = { key: "subscription", name: "Subscription", detail: S.trialDays + "-day trial, then " + money(cents(S.renewalPrice)) + " every " + S.periodDays + " days", price: 0, compareAt: null, qty: 1, plan: S.planId || null };
    }
    var priced = lines.concat(sub ? [sub] : []);
    var subtotal = priced.reduce(function (t, l) { return t + (l.price || 0); }, 0);
    var savings = lines.reduce(function (t, l) { return t + (l.compareAt ? l.compareAt - l.price : 0); }, 0);
    var shipFree = !(Number(C.shipping.price) > 0);
    var shipping = opts.shippingAddress ? (shipFree ? 0 : cents(C.shipping.price)) : null;
    var gift = C.gift ? { name: C.gift.name, qty: o.units * (C.gift.perUnit || 1), price: 0, compareAt: cents(C.gift.compareAt), image: C.gift.image } : null;

    var blockers = [];
    if (!(C.whop && C.whop.paymentsEnabled)) blockers.push("Payments are switched off for this preview.");
    priced.forEach(function (l) { if (!l.plan && !l.free) blockers.push(l.name + " (" + l.detail + "): no Whop plan is configured."); if (l.price == null) blockers.push(l.name + ": no approved price."); });
    if (!shipFree && !C.shipping.planId) blockers.push(C.shipping.label + ": no Whop shipping plan is configured.");
    if (SUBS && !C.subscriptions.disclosure) blockers.push("Subscription: the owner's subscription disclosure is not configured yet.");
    if (SUBS && !C.subscriptions.cancellationTerms) blockers.push("Subscription: the cancellation terms are not configured yet.");
    if (shipping == null) blockers.push("Enter a complete US shipping address to calculate shipping.");

    var whopItems = [{ plan: lines[0].plan, quantity: 1 }]
      .concat(sub ? [{ plan: sub.plan, quantity: 1 }] : [])
      .concat(lines.slice(1).filter(function (l) { return !l.free; }).map(function (l) { return { plan: l.plan, quantity: 1 }; }))
      .concat(!shipFree && C.shipping.planId && shipping != null ? [{ plan: C.shipping.planId, quantity: 1 }] : []);

    return { state: s, offer: o, lines: lines, subscription: sub, itemCount: lines.length + (sub ? 1 : 0), gift: gift,
      subtotal: subtotal, savings: savings, shipping: shipping, shippingPending: shipping == null, total: subtotal + (shipping || 0),
      blockers: blockers, payable: blockers.length === 0, whopItems: whopItems };
  }
  var stock = { left: {}, preorder: false, window: null };
  C.offers.forEach(function (o) { o.listedSoldOut = !!o.soldOut; });
  function loadStock() {
    return fetch(C.checkout.apiUrl + "/stock").then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      if (!d || !d.offers) return;
      stock = { left: d.offers, preorder: !!d.preorder, window: d.window || null };
      C.offers.forEach(function (o) { o.soldOut = !stock.preorder && (o.listedSoldOut || d.offers[o.id] === 0); });
      var open = C.offers.filter(function (o) { return !o.soldOut; });
      if (offerById(state.offer).soldOut && open.length) set({ offer: open[0].id }); else emit();
    }).catch(function () {});
  }
  function cartChoice(s) {
    s = s || state; var a = {};
    Object.keys(s.addons).forEach(function (k) { a[k] = s.addons[k]; });
    return { offer: s.offer, addons: a };
  }

  window.StoreCart = {
    get: function () { return state; },
    set: set,
    reset: function () { state = defaults(); write(state); emit(); },
    order: order,
    cartChoice: cartChoice,
    onChange: function (fn) { listeners.push(fn); },
    money: money,
    cents: cents,
    unitsLabel: unitsLabel,
    offerById: offerById,
    groupById: groupById,
    addonRule: addonRule,
    loadStock: loadStock,
    stock: function () { return stock; },
    subscriptions: SUBS,
  };
})();
